import { render, staticRenderFns } from "./CustomersCmp.template.html?vue&type=template&id=47d6a0c6&scoped=true&external"
import script from "./CustomersCmp.options.js?vue&type=script&lang=js&external"
export * from "./CustomersCmp.options.js?vue&type=script&lang=js&external"
import style0 from "./CustomersCmp.vue?vue&type=style&index=0&id=47d6a0c6&lang=css"
import style1 from "./CustomersCmp.vue?vue&type=style&index=1&id=47d6a0c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6a0c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d6a0c6')) {
      api.createRecord('47d6a0c6', component.options)
    } else {
      api.reload('47d6a0c6', component.options)
    }
    module.hot.accept("./CustomersCmp.template.html?vue&type=template&id=47d6a0c6&scoped=true&external", function () {
      api.rerender('47d6a0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/cmp/CustomersCmp.vue"
export default component.exports